import React, { useEffect, useContext, useState, Fragment } from 'react'
import { SRLWrapper } from "simple-react-lightbox";
import { AuthContext } from '../../../App/App';
import jwt from 'jwt-decode'
import swal from 'sweetalert';
import { ContentBodyContext } from '../MainContent';

function WhatsappStatus() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext)
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const token = jwt(localStorage.getItem('token-helpdesk-umy'))

    const handleClickCard = () => {
        if (token.role_id == 1) {
            dispatchAuth({
                type: 'PATH',
                page: 'Whatsapp Number'
            })
        }
    }

    //init content 
    const initialState = {
        id: token.work_unit_id,
        description: `Assign by ${token.user}`,
        qrcode: (stateContentBody.whatsappAuth.status == true) ? <img className="gallery-item" src='./assets/img/whatsapp-icon.png' data-title="QRCode"></img> : <img className="gallery-item" src='./assets/img/loading.gif' data-title="QRCode"></img>,
        message: (stateContentBody.whatsappAuth.status == true) ? "Connected" : "Disconnected",
    }
    const [whatsappStatus, setWhatsappStatus] = useState(initialState)

    useEffect(() => {
        if (stateContentBody.whatsappAuth.status == true) {
            setWhatsappStatus({
                ...whatsappStatus,
                message: "Ready to use",
                qrcode: <img className="gallery-item" src='./assets/img/whatsapp-icon.png' data-title="QRCode"></img>
            })
        }
    }, [stateContentBody.whatsappAuth.status, stateAuth.page])

    //create and init whatsapp session 
    useEffect(() => {
        if (whatsappStatus.id != null && whatsappStatus.description != null && stateContentBody.whatsappAuth.status == false) {
            //create  whatsapp session
            setWhatsappStatus({
                ...whatsappStatus,
                message: "load QRCode, please wait!",
                qrcode: <img className="gallery-item" src='./assets/img/loading.gif' data-title="QRCode"></img>
            })
            stateContentBody.socket.emit('create-session', {
                id: whatsappStatus.id,
                description: whatsappStatus.description
            })
        }

        //init session
        stateContentBody.socket.on(`init-${whatsappStatus.id}`, function (res) {
            if (res.id == whatsappStatus.id) {
                if (res.ready) {
                    setWhatsappStatus({
                        ...whatsappStatus,
                        message: "Ready to use",
                        qrcode: <img className="gallery-item" src='./assets/img/whatsapp-icon.png' data-title="QRCode"></img>
                    })

                    dispatchContentBody({
                        type: "WA_STATUS",
                        status: true,
                        trigger: null
                    })
                } else {
                    setWhatsappStatus({
                        ...whatsappStatus,
                        message: "load QRCode, please wait!",
                        qrcode: <img className="gallery-item" src='./assets/img/loading.gif' data-title="QRCode"></img>,
                    })

                    dispatchContentBody({
                        type: "WA_STATUS",
                        status: false,
                        trigger: null
                    })
                }
            }
        })
    }, [whatsappStatus.id, stateContentBody.whatsappAuth.status])

    //remove session
    useEffect(() => {
        if (whatsappStatus.id != null && whatsappStatus.description != null && stateContentBody.whatsappAuth.status == true) {
            stateContentBody.socket.on(`remove-session-${whatsappStatus.id}`, function (id) {
                swal("Warning!", `Whatsapp was  disconnected!`, "warning", {
                    button: "OK",
                });
                setWhatsappStatus({
                    ...whatsappStatus,
                    message: "load QRCode, please wait!",
                    qrcode: <img className="gallery-item" src='./assets/img/loading.gif' data-title="QRCode"></img>
                })

                dispatchContentBody({
                    type: "WA_STATUS",
                    status: false,
                    trigger: null
                })

                stateContentBody.socket.emit('create-session', {
                    id: whatsappStatus.id,
                    description: whatsappStatus.description
                });
            });

            stateContentBody.socket.on(`auth-failur-${whatsappStatus.id}`, function (data) {
                dispatchContentBody({
                    type: "WA_STATUS",
                    status: false,
                    trigger: null,
                })
                setWhatsappStatus({
                    ...whatsappStatus,
                    message: "Authentication Failed",
                    qrcode: <img className="gallery-item" src='./assets/img/whatsapp-icon-red.png' data-title="QRCode"></img>,
                })

                swal("Warning!", `${data.message}`, "warning", {
                    button: "OK",
                });
            });
        }
    }, [stateContentBody.whatsappAuth.status])

    //QRCode update
    useEffect(() => {
        stateContentBody.socket.on(`qr-${whatsappStatus.id}`, function (res) {
            setWhatsappStatus({
                ...whatsappStatus,
                qrcode: (<SRLWrapper>
                    <img className="gallery-item" src={res.src} data-title="QRCode"></img>
                </SRLWrapper>),
                message: "Click QR Code to enlarge",
            })
            dispatchContentBody({
                type: "WA_STATUS",
                status: false,
                trigger: null
            })
        })
    }, [whatsappStatus.id])

    useEffect(() => {
        stateContentBody.socket.on(`ready-${whatsappStatus.id}`, function (data) {
            if (data.message.status == "error") {
                swal("Error!", `${data.message.message}`, "error", {
                    button: "OK",
                });
            }
            dispatchContentBody({
                type: "WA_STATUS",
                status: true,
                trigger: null
            })

            setWhatsappStatus({
                ...whatsappStatus,
                message: "Ready to use",
                qrcode: <img className="gallery-item" src='./assets/img/whatsapp-icon.png' data-title="QRCode"></img>,
            })
        })
        stateContentBody.socket.on(`authenticated-${whatsappStatus.id}`, function (data) {
            dispatchContentBody({
                type: "WA_STATUS",
                status: true,
                trigger: null
            })
        })

        stateContentBody.socket.on(`whatsapp-restart-callback-${token.work_unit_id}`, function (data) {
            dispatchContentBody({
                type: "WA_STATUS",
                status: null,
                trigger: null
            })

            swal("Info!", `${data.message}`, "info", {
                button: "OK",
            });
        })
    }, [stateContentBody.whatsappAuth.status, whatsappStatus.id])

    return (
        <Fragment>
            <div className="col-lg-4 col-md-6 col-sm-6 col-12" onClick={handleClickCard} style={{ cursor: 'pointer' }}>
                <div className="card card-statistic-1">
                    {stateContentBody.whatsappContact != null ? (
                        <Fragment>
                            <div className="card-icon" onClick={(e) => e.stopPropagation()}>
                                <div className="gallery gallery-md">
                                    {whatsappStatus.qrcode}
                                </div>
                            </div>
                            <div className="card-wrap">
                                <div className="card-header">
                                    <h4>WhatsApp is {`${stateContentBody.whatsappAuth.status == true ? 'connected' : 'disconnected'}`}</h4>
                                </div>
                                <div className="card-body">
                                    {whatsappStatus.message}
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <div className="card-icon bg-secondary">
                                <i className="fab fa-whatsapp" style={{ fontSize: '40px' }}></i>
                            </div>
                            <div className="card-wrap">
                                <div className="card-header">
                                    <h4>Whatsapp is not found</h4>
                                </div>
                                <div className="card-body">
                                    Click here to set whatsapp number
                                </div>
                            </div>
                        </Fragment>
                    )}
                </div>
            </div>
        </Fragment>
    )
}

export default WhatsappStatus